import Vue from 'vue';
import vuetify from './plugins/vuetify';
import App from './components/App.vue';
import VueRouter from "vue-router";
import Meta from 'vue-meta'
import router from './lib/router';
import store from './lib/store';
// import './lib/app_init';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Meta);

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');

